import React from 'react'

const Option = ({setTurnOn}) => {
  return (
    <div className='my-3 flex justify-between'>


<div className=" font-Laila flex flex-col md:flex-row gap-3 text-primary-red text-base font-bold sm:text-lg">
            <div className="border-primary-blue bg-primary-red flex items-center  justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="old">पहिले नै हामीसंग आवद्ध भएको कम्पनी</label>
              <input type="radio" defaultChecked name="radio-btn" id="old"
                 onChange={()=> setTurnOn(true)}
               />
            </div>
            <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="new">नयाँ कम्पनी </label>
              <input type="radio" name="radio-btn" id="new"
              onChange={()=> setTurnOn(false)}
              />
            </div>
          </div>
    </div>
  )
}

export default Option